import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { UnlockMessagePhotoResponse } from '@app/modules/messaging/models/api.model'
import type { Message } from '@app/modules/messaging/models/message.model'

export const messagePhotoEvents = eventGroup({
  source: 'Message Photo',
  events: {
    unlock: type<{
      message: Message & { type: 'photo'; status: 'locked' }
      profile_id: number
    }>(),
    unlockSuccess: type<{ response: UnlockMessagePhotoResponse }>(),
    unlockFailure: type<{
      error: any
      profile_id: number
    }>(),
    unlockEnd: type<{ messageTimestamp: Message['timestamp'] }>(),
    view: type<{ message: Message & { type: 'photo'; status: 'viewable' } }>(),
  },
})
